import React from 'react';
import { MathboxLine } from '../Lines';

const TotalVehiclePrice = ({ pricing, isFamilyFirst }) => {
  return (
    <div
      className={
        isFamilyFirst
          ? 'math-box-employee-price'
          : 'math-box__total-vehicle-price'
      }>
      <MathboxLine
        labelKey="total.msrp.v3"
        className="total-vehicle-price"
        price={pricing.totalVehiclePrice.text}
      />
    </div>
  );
};

export default TotalVehiclePrice;
